import { Input } from "@ui";
import style from "./SearchContainer.module.scss";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { changeActiveTags, setActiveSearchParameter } from "@global-state/pages/user/myProxies/slice";
import { useEffect, useRef, useState } from "react";
import cn from "classnames";
import { useGetAllTagsQuery } from "@RTKQuery/user/tags/tags";

export function SearchContainer() {
    const { data } = useGetAllTagsQuery();

    const [valueTagInput, setValueTagInput] = useState<string>("");

    const { activeSearchParameter, activeTags } = useAppSelector(state => state.myProxiesUserPage);

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const refContainer = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        function handleClick(e: any) {
            if (!refContainer.current?.contains(e.target)) {
                setIsOpen(false);
            }
        }

        document.documentElement.addEventListener("click", handleClick);

        return () => {
            document.documentElement.removeEventListener("click", handleClick);
        };
    }, []);

    const dispatch = useAppDispatch();
 
    return (
        <div ref={refContainer} className={style.container}>

            <Input
                value={activeSearchParameter}
                onChange={(value) => dispatch(setActiveSearchParameter(value))}
                type="search"
                onClick={() => setIsOpen(state => !state)}
                onSearch={(value) => dispatch(setActiveSearchParameter(value))}
                label={{
                    text: "Пошук по id або паролю проксі"
                }}
                customStyle={{
                    width: "!min-w-[320px] max-md:!min-w-[150px] max-md:!w-full max-md:!max-w-full",
                    height: "!h-[36px]"
                }}
            />
            <div className={cn(style.listTags, isOpen && "!flex")}>
                <Input
                    value={valueTagInput}
                    onChange={(value) => setValueTagInput(value)}
                    customStyle={{
                        width: "!w-full !max-w-full mb-[10px]",
                        height: "!h-[30px]"
                    }}
                    label="Пошук по тегах"
                />
                <div data-scrollable className="flex-col flex w-full pr-[5px] overflow-auto gap-[10px]">
                    {
                        data?.filter(item => item.name.includes(valueTagInput)).map(item => (
                            <button
                                key={item.id}
                                className={cn(
                                    style.colName,
                                    activeTags.includes(item.id) && style.colName_active,
                                )}
                                onClick={() => {
                                    dispatch(changeActiveTags(item.id))
                                }}
                            >
                                # {item.name}
                            </button>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}
